import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: 'trial-ended',
    name: 'client-trial-ended',
    component: () => import('./TrialEnded.vue'),
  },
] satisfies RouteRecordRaw[];
